export const ActiveAndPastJobDetailsTypes = {
  GET_ACTIVE_PAST_JOB_DETAILS: 'GET_ACTIVE_PAST_JOB_DETAILS',
};
